import React from 'react'
import { array, string } from 'prop-types'
import { EventSponsorLinkedArticles } from '@/component/Primitive/Events'

const EventSponsorLinkedArticlesWidget = (props) => {
  const { title, linkedArticles } = props

  return <EventSponsorLinkedArticles title={title} articles={linkedArticles} />
}

EventSponsorLinkedArticlesWidget.propTypes = {
  title: string,
  linkedArticles: array
}

export default EventSponsorLinkedArticlesWidget
